// extracted by mini-css-extract-plugin
export var btn = "MeterReading-module--btn--XUECX";
export var component = "MeterReading-module--component--fC+dS";
export var form = "MeterReading-module--form--XH8HW";
export var formWrapper = "MeterReading-module--formWrapper--gMiBH";
export var info = "MeterReading-module--info--YCukw";
export var link = "MeterReading-module--link--+gDv1";
export var loader = "MeterReading-module--loader--qb7rK";
export var roundIcon = "MeterReading-module--roundIcon--a-AiL";